import React, { useEffect, useState } from "react";
import { setTitle } from "../helpers/MetaTag";
import { useSelector } from "react-redux";
import { postData } from "../services/api";
import { Document, pdf, PDFDownloadLink } from "@react-pdf/renderer";
import NoDataFound from "../components/NoDataFound";
import { API_URL } from "../config/host";

import { useTranslation } from "react-i18next";
import ReportTableSkeleton from "../components/loader/ReportTableSkeleton";
import PerspectiveOverallReport from "./pdf/PerspectiveOverallReport";
import Button from "../components/form/Button";
import DeletePopup from "../components/DeletePopup";
import toastr from "toastr";

const ProspectiveBoardMemberReport = () => {
  setTitle("Succession Planning Software for your Business with Succession Now | Prospective Board Member Report"
  );
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth?.user);
  const [loading, setLoading] = useState(false);
  const [perspectives, setPerspectives] = useState([]);
  const [enabledDeletePopup, setenabledDeletePopup] = useState(false);
  const [currentId, setCurrentId] = useState("");
  const [message, setMessage] = useState("");
  const [actionValue, setActionValue] = useState({});

  useEffect(() => {
    async function proposedBoardMemberReport() {
      setLoading(true);
      try {
        const result = await postData("proposed-board-member/report", {
          sortQuery: { created_at: 1 },
          type: "boardmember",
        });
        if (result.data) {
          setPerspectives(result.data);
          setLoading(false);
        } else {
          console.log("Advance desire message", result.message);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log("Error advance desire catch", error.message);
      }
    }
    proposedBoardMemberReport();
  }, []);


  const handleDownloadClick = async (e) => {
    e.preventDefault();

    // Open a blank tab immediately to avoid pop-up blockers.
    const newTab = window.open("", "_blank");

    // Display a styled loading message with Tailwind CSS.
    newTab.document.write(`
            <html lang="en">
              <head>
                <script src="https://cdn.tailwindcss.com"></script>
                <style>
                  body {
                    @apply bg-gray-100;
                    margin: 0;
                    height: 100vh;
                  }
                  .loader-container {
                    @apply flex flex-col justify-center items-center h-screen;
                  }
                  .loader {
                    width: 50px;
                    aspect-ratio: 1;
                    display: grid;
                    border-radius: 50%;
                    background:
                      linear-gradient(0deg, rgb(0 0 0 / 50%) 30%, #0000 0 70%, rgb(0 0 0 / 100%) 0) 50% / 8% 100%,
                      linear-gradient(90deg, rgb(0 0 0 / 25%) 30%, #0000 0 70%, rgb(0 0 0 / 75%) 0) 50% / 100% 8%;
                    background-repeat: no-repeat;
                    animation: l23 1s infinite steps(12);
                  }
                  .loader::before,
                  .loader::after {
                    content: "";
                    grid-area: 1 / 1;
                    border-radius: 50%;
                    background: inherit;
                    opacity: 0.915;
                    transform: rotate(30deg);
                  }
                  .loader::after {
                    opacity: 0.83;
                    transform: rotate(60deg);
                  }
                  @keyframes l23 {
                    100% {
                      transform: rotate(1turn);
                    }
                  }
                </style>
              </head>
              <body>
               <div class="flex justify-center items-center mt-20 loader-container">
                <div class="flex flex-col items-center justify-center space-y-4">
                  <div class="loader"></div>
                  <p class="text-teal-700 text-lg font-semibold mt-4">Generating your PDF... Please wait.</p>
                </div>
               </div>
              </body>
            </html>
            `);

    try {
      // Generate the PDF blob asynchronously.
      const blob = await pdf(
        <Document>
          <PerspectiveOverallReport
            title={t("prospective_board_member_report")}
            headingTitle={t("prospective_board_members")}
            user={user}
            companyLogo={API_URL + user?.image}
            type={"boardmember"}
            perspectiveReport={perspectives}
          />
        </Document>
      ).toBlob();

      // Create a URL from the blob.
      const blobURL = URL.createObjectURL(blob);
      // Redirect the new tab to the blob URL (load the PDF).
      newTab.location.href = blobURL;
    } catch (error) {
      // Display an error message in the new tab.
      newTab.document.body.innerHTML = `
              <div class="flex flex-col items-center justify-center h-screen bg-red-100">
                <p class="text-red-700 text-lg font-semibold">Failed to load PDF. Please try again later.</p>
                <p class="text-sm text-gray-600">${error.message}</p>
              </div>
            `;
      console.error("PDF generation error:", error);
    }
  };

   useEffect(() => {
    const loadDeleteRecord = async () => {
      try {
        const statusData = await postData("prospective-board-member/delete", {
          id: actionValue?.row_id,
        });
        if (statusData.status === 200) {
          setPerspectives((member) => member.filter((item) => item._id !== actionValue.row_id));
        } else {
          toastr.error(statusData.message);
        }
      } catch (error) {
        toastr.error(error.message);
      }
    };
    if (actionValue && actionValue.button_type === "delete") {
      loadDeleteRecord();
    }
  }, [actionValue]);

  return (
    <>
      <div className="relative flex justify-between items-center mb-4 flex-wrap sm:flex-nowrap gap-y-4">
        <div>
          <div className="text-xl md:text-3xl text-slate-800 font-bold">
            {t("prospective_board_member_report") + " - " + user?.company_name}
          </div>
        </div>
        <div className="sm:ml-auto flex justify-end items-center space-x-2">
          <button
            type={"button"}
            className={
              "flex justify-center items-center gap-2 bg-teal-500 text-white rounded text-base sm:text-lg h-8 sm:h-10 py-0 px-2 sm:px-3 transition-all duration-200 cursor-pointer"
            }
            onClick={(e) => handleDownloadClick(e)}
          >
            <i className={"fa-fw fa-solid fa-file-pdf"}></i>
            <div className={"text-xs sm:text-sm font-medium whitespace-nowrap"}>
              Download Pdf
            </div>
          </button>
        </div>
      </div>
      {/* <div className="relative flex gap-4 items-center mb-4">
        <div className="relative z-20">
          <DropdownCheckbox data={positions} functions={positionSelect} />
        </div>
      </div> */}

      <div className="w-full overflow-auto scroll-smooth scrollbar min-h-[480px]">
        <table className="min-w-max w-full table-auto">
          <tbody className="text-slate-700 text-sm font-light bg-slate-300 divide-y divide-slate-200">
            <tr className="text-white font-bold text-sm leading-none bg-slate-900 !border-none">
              <th className="py-4 px-2 text-left max-w-[240px] z-10">Name</th>
              <th className="py-4 px-2  max-w-[240px] z-10">
                Level of Education
              </th>
              <th className="py-4 px-2  max-w-[240px] z-10">Field of Study</th>
              <th className="py-4 px-2  max-w-[240px] z-10">
                Industry Experience
              </th>
              <th className="py-4 px-2  max-w-[240px] z-10">
                &nbsp;
              </th>
            </tr>
            {perspectives && perspectives.length > 0 ? (
              perspectives.map((items, index) => (
                <tr className="bg-white" key={index}>
                  <td className="py-3 px-2 font-semibold text-sm text-left max-w-[240px] align-top">
                    {items?.first_name + " " + items?.last_name}
                    {/* <span className="block text-xs font-bold leading-tight text-teal-500">{items?.position_details ? items?.position_details[0]?.short_name : "N/A"}</span> */}
                  </td>
                  <td
                    key={index}
                    className="py-3 px-2 text-left max-w-[240px] align-top"
                  >
                    <div className="relative flex justify-center text-xs font-medium text-slate-700 bg-white py-2 px-3 border border-slate-200 rounded">
                      {items?.education_details
                        ? items?.education_details?.name
                        : "N/A"}
                    </div>
                  </td>
                  <td
                    key={index}
                    className="py-3 px-2 text-left max-w-[240px] align-top"
                  >
                    <div className="relative flex justify-center text-xs font-medium text-slate-700 bg-white py-2 px-3 border border-slate-200 rounded">
                      {items?.study_details
                        ? items?.study_details?.name
                        : "N/A"}
                    </div>
                  </td>
                  <td
                    key={index}
                    className="py-3 px-2 text-left max-w-[240px] align-top"
                  >
                    <div className="relative flex flex-col justify-center text-xs font-medium text-slate-700 bg-white py-2 px-3 border border-slate-200 rounded">
                      <div className="relative before:content-[''] before:absolute before:top-1.5 before:left-0 before:w-1 before:h-1 before:bg-black before:rounded-full pl-4">
                        {items?.industry_details
                          ? items?.industry_details?.name
                          : "N/A"}
                      </div>
                      {
                        items?.industry_one_details && 
                        <div className="relative before:content-[''] before:absolute before:top-1.5 before:left-0 before:w-1 before:h-1 before:bg-black before:rounded-full pl-4">
                          {items?.industry_one_details
                            ? items?.industry_one_details?.name
                            : "N/A"}
                        </div>
                      }
                      {
                        items?.industry_two_details && 
                        <div className="relative before:content-[''] before:absolute before:top-1.5 before:left-0 before:w-1 before:h-1 before:bg-black before:rounded-full pl-4">
                          {items?.industry_two_details
                            ? items?.industry_two_details?.name
                            : "N/A"}
                        </div>
                      }                      
                    </div>
                  </td>
                  <td
                    key={index}
                    className="py-3 px-2 text-left max-w-[240px] align-top"
                  >
                    <Button
                        buttonClasses={
                          "!p-0 !flex !items-center !justify-center !text-sm !bg-transparent !text-rose-500 !w-4 !h-4"
                        }
                        buttonType={"button"}
                        buttonIcon={"fa-regular fa-trash"}
                        buttonIconPosition={"left"}
                        buttonHasLink={false}
                        functions={() => {
                          setenabledDeletePopup(true);
                          setCurrentId(items?._id);
                          setMessage(
                            t("you_are_about_to_delete_the_prospective_board_member") +
                              items?.first_name +
                              ". " +
                              t(
                                "please_click_confirm_to_delete_this_prospective_board_member"
                              )
                          );
                        }}
                      />
                  </td>
                </tr>
              ))
            ) : (
              <tr className="!border-none">
                {loading ? (
                  <td className="p-0 text-left" colSpan={11}>
                    <div className="space-y-5">
                      <ReportTableSkeleton />
                      <ReportTableSkeleton />
                    </div>
                  </td>
                ) : (
                  <td className="text-left p-0" colSpan={11}>
                    <NoDataFound label={t("no_data_found")} />
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup}
          setIsOpen={(val) => setenabledDeletePopup(val)}
          currentId={currentId}
          getActionValue={(obj) => {
            setActionValue(obj);
            setenabledDeletePopup(false);
            setCurrentId("");
          }}
          message={message}
        />
      )}
    </>
  );
};

export default ProspectiveBoardMemberReport;
